// extracted by mini-css-extract-plugin
export default {"root":"ErrorPage_root__J-Gfo","row":"ErrorPage_row__YKEmE","column":"ErrorPage_column__c6Xlj","textContainer":"ErrorPage_textContainer__LBvow"};